import React from "react";
import SubmiticaLogo from "assets/img/submitica-s.png";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme, useMediaQuery, styled } from "@mui/material";
import { SubmiticaGreen } from "styles/colours";

const Logo = styled("img")(() => ({
  height: "75px",
  margin: "0"
}));

const ButtonProgress = styled(CircularProgress)(() => ({
  color: SubmiticaGreen,
  position: "absolute"
}));

type LoaderProps = {
  isPartial?: boolean;
};

const Loader = (props: LoaderProps) => {
  const isScreenSmall = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        minHeight: props.isPartial ? "250px" : "",
        height: props.isPartial
          ? ""
          : isScreenSmall
          ? "calc(100vh - 140px)"
          : "calc(100vh - 70px)",
        width: "100%",
        alignItems: "center"
      }}
    >
      <ButtonProgress size={160} thickness={1}></ButtonProgress>
      <Logo style={{ marginTop: "0", marginLeft: "0" }} src={SubmiticaLogo} />
    </div>
  );
};

export default Loader;
